import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";

// Material-UI Icon
import FolderIcon from "@material-ui/icons/Folder";
import GetAppIcon from "@material-ui/icons/GetApp";

// Custom Component
// import DetailReportUploadChip from '../Chip/DetailReportUploadChip'
import FileImportChip from "../Chip/FileImportChip";

// Custom Style
import detailReportDropzoneContentStyle from "../../styles/jss/components/labMain/detailReportDropzoneContentStyle";

const useStyles = makeStyles((theme) =>
  detailReportDropzoneContentStyle(theme)
);

const DetailReportDropzoneContent = (props) => {
  const { open, exportExcel, onPreviewAction, onRemoveAction } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  // Redux Data
  const importFileRedux = useSelector((state) => state.importFileRedux);
  // Redux Data

  useEffect(() => {});

  return (
    <Fragment>
      <Box className={classes.dropzoneArea}>
        {importFileRedux !== null ? (
          <FileImportChip
            filename={importFileRedux.name}
            fileSize={importFileRedux.size}
            fileExtension={"xlsx"}
          />
        ) : (
          ""
        )}

        <Box className={classes.buttonArea}>
          <Tooltip title="Download Excel Template">
            <Fab
              aria-label="excel_tamplate"
              color="primary"
              size="small"
              onClick={exportExcel}
              className={classes.icon}
            >
              <GetAppIcon />
            </Fab>
          </Tooltip>
          &nbsp;
          <Tooltip title="Choose Excel">
            <Fab
              color="primary"
              size="small"
              aria-label="add_recipient"
              className={classes.icon}
              onClick={open}
            >
              <FolderIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Box>
    </Fragment>
  );
};

export default DetailReportDropzoneContent;
